import { useState, useEffect } from 'react';

// Bible books data
export const bibleBooks = [
  { id: 'GEN', name: 'Genesis', chapters: 50 },
  { id: 'EXO', name: 'Exodus', chapters: 40 },
  { id: 'LEV', name: 'Leviticus', chapters: 27 },
  { id: 'NUM', name: 'Numbers', chapters: 36 },
  { id: 'DEU', name: 'Deuteronomy', chapters: 34 },
  { id: 'JOS', name: 'Joshua', chapters: 24 },
  { id: 'JDG', name: 'Judges', chapters: 21 },
  { id: 'RUT', name: 'Ruth', chapters: 4 },
  { id: '1SA', name: '1 Samuel', chapters: 31 },
  { id: '2SA', name: '2 Samuel', chapters: 24 },
  { id: '1KI', name: '1 Kings', chapters: 22 },
  { id: '2KI', name: '2 Kings', chapters: 25 },
  { id: '1CH', name: '1 Chronicles', chapters: 29 },
  { id: '2CH', name: '2 Chronicles', chapters: 36 },
  { id: 'EZR', name: 'Ezra', chapters: 10 },
  { id: 'NEH', name: 'Nehemiah', chapters: 13 },
  { id: 'EST', name: 'Esther', chapters: 10 },
  { id: 'JOB', name: 'Job', chapters: 42 },
  { id: 'PSA', name: 'Psalms', chapters: 150 },
  { id: 'PRO', name: 'Proverbs', chapters: 31 },
  { id: 'ECC', name: 'Ecclesiastes', chapters: 12 },
  { id: 'SNG', name: 'Song of Solomon', chapters: 8 },
  { id: 'ISA', name: 'Isaiah', chapters: 66 },
  { id: 'JER', name: 'Jeremiah', chapters: 52 },
  { id: 'LAM', name: 'Lamentations', chapters: 5 },
  { id: 'EZK', name: 'Ezekiel', chapters: 48 },
  { id: 'DAN', name: 'Daniel', chapters: 12 },
  { id: 'HOS', name: 'Hosea', chapters: 14 },
  { id: 'JOL', name: 'Joel', chapters: 3 },
  { id: 'AMO', name: 'Amos', chapters: 9 },
  { id: 'OBA', name: 'Obadiah', chapters: 1 },
  { id: 'JON', name: 'Jonah', chapters: 4 },
  { id: 'MIC', name: 'Micah', chapters: 7 },
  { id: 'NAM', name: 'Nahum', chapters: 3 },
  { id: 'HAB', name: 'Habakkuk', chapters: 3 },
  { id: 'ZEP', name: 'Zephaniah', chapters: 3 },
  { id: 'HAG', name: 'Haggai', chapters: 2 },
  { id: 'ZEC', name: 'Zechariah', chapters: 14 },
  { id: 'MAL', name: 'Malachi', chapters: 4 },
  { id: 'MAT', name: 'Matthew', chapters: 28 },
  { id: 'MRK', name: 'Mark', chapters: 16 },
  { id: 'LUK', name: 'Luke', chapters: 24 },
  { id: 'JHN', name: 'John', chapters: 21 },
  { id: 'ACT', name: 'Acts', chapters: 28 },
  { id: 'ROM', name: 'Romans', chapters: 16 },
  { id: '1CO', name: '1 Corinthians', chapters: 16 },
  { id: '2CO', name: '2 Corinthians', chapters: 13 },
  { id: 'GAL', name: 'Galatians', chapters: 6 },
  { id: 'EPH', name: 'Ephesians', chapters: 6 },
  { id: 'PHP', name: 'Philippians', chapters: 4 },
  { id: 'COL', name: 'Colossians', chapters: 4 },
  { id: '1TH', name: '1 Thessalonians', chapters: 5 },
  { id: '2TH', name: '2 Thessalonians', chapters: 3 },
  { id: '1TI', name: '1 Timothy', chapters: 6 },
  { id: '2TI', name: '2 Timothy', chapters: 4 },
  { id: 'TIT', name: 'Titus', chapters: 3 },
  { id: 'PHM', name: 'Philemon', chapters: 1 },
  { id: 'HEB', name: 'Hebrews', chapters: 13 },
  { id: 'JAS', name: 'James', chapters: 5 },
  { id: '1PE', name: '1 Peter', chapters: 5 },
  { id: '2PE', name: '2 Peter', chapters: 3 },
  { id: '1JN', name: '1 John', chapters: 5 },
  { id: '2JN', name: '2 John', chapters: 1 },
  { id: '3JN', name: '3 John', chapters: 1 },
  { id: 'JUD', name: 'Jude', chapters: 1 },
  { id: 'REV', name: 'Revelation', chapters: 22 }
];

// Common abbreviations, misspellings, and alternate names → the exact `name`
// used in `bibleBooks` above. Without this, "Psalm 42" fails to resolve because
// the canonical entry is "Psalms" — which silently breaks commentary lookup.
const BOOK_ALIASES: Record<string, string> = {
  // OT
  'gen': 'genesis', 'ge': 'genesis', 'gn': 'genesis',
  'ex': 'exodus', 'exo': 'exodus', 'exod': 'exodus',
  'lev': 'leviticus', 'lv': 'leviticus',
  'num': 'numbers', 'nm': 'numbers', 'nu': 'numbers',
  'deut': 'deuteronomy', 'deu': 'deuteronomy', 'dt': 'deuteronomy',
  'josh': 'joshua', 'jos': 'joshua',
  'judg': 'judges', 'jdg': 'judges',
  'rut': 'ruth', 'rth': 'ruth',
  '1 sam': '1 samuel', '2 sam': '2 samuel', '1 sa': '1 samuel', '2 sa': '2 samuel',
  '1 kgs': '1 kings', '2 kgs': '2 kings', '1 ki': '1 kings', '2 ki': '2 kings',
  '1 chron': '1 chronicles', '2 chron': '2 chronicles',
  '1 chr': '1 chronicles', '2 chr': '2 chronicles',
  'ezr': 'ezra', 'neh': 'nehemiah', 'est': 'esther', 'esth': 'esther',
  'jb': 'job',
  'psalm': 'psalms', 'ps': 'psalms', 'psa': 'psalms', 'pss': 'psalms', 'psalter': 'psalms',
  'prov': 'proverbs', 'prv': 'proverbs', 'pro': 'proverbs',
  'eccl': 'ecclesiastes', 'ecc': 'ecclesiastes', 'eccles': 'ecclesiastes', 'qoheleth': 'ecclesiastes',
  'song': 'song of solomon', 'songs': 'song of solomon',
  'song of songs': 'song of solomon', 'canticles': 'song of solomon', 'sos': 'song of solomon',
  'isa': 'isaiah', 'is': 'isaiah',
  'jer': 'jeremiah', 'lam': 'lamentations',
  'ezek': 'ezekiel', 'ezk': 'ezekiel', 'eze': 'ezekiel',
  'dan': 'daniel', 'dn': 'daniel',
  'hos': 'hosea', 'jl': 'joel', 'am': 'amos',
  'obad': 'obadiah', 'oba': 'obadiah',
  'jon': 'jonah', 'mic': 'micah',
  'nah': 'nahum', 'nam': 'nahum',
  'hab': 'habakkuk', 'zeph': 'zephaniah', 'zep': 'zephaniah',
  'hag': 'haggai', 'zech': 'zechariah', 'zec': 'zechariah',
  'mal': 'malachi',
  // NT
  'matt': 'matthew', 'mt': 'matthew', 'mat': 'matthew',
  'mk': 'mark', 'mrk': 'mark', 'mr': 'mark',
  'lk': 'luke', 'luk': 'luke',
  'jn': 'john', 'jhn': 'john',
  'act': 'acts', 'acts of the apostles': 'acts',
  'rom': 'romans', 'rm': 'romans',
  '1 cor': '1 corinthians', '2 cor': '2 corinthians',
  '1 co': '1 corinthians', '2 co': '2 corinthians',
  '1 corinthans': '1 corinthians', '2 corinthans': '2 corinthians',
  'gal': 'galatians', 'eph': 'ephesians',
  'phil': 'philippians', 'php': 'philippians',
  'phillipians': 'philippians', 'philipians': 'philippians',
  'col': 'colossians',
  '1 thess': '1 thessalonians', '2 thess': '2 thessalonians',
  '1 thes': '1 thessalonians', '2 thes': '2 thessalonians',
  '1 th': '1 thessalonians', '2 th': '2 thessalonians',
  '1 tim': '1 timothy', '2 tim': '2 timothy',
  '1 ti': '1 timothy', '2 ti': '2 timothy',
  'tit': 'titus', 'ti': 'titus',
  'philem': 'philemon', 'phlm': 'philemon', 'phm': 'philemon',
  'heb': 'hebrews', 'jas': 'james', 'jm': 'james',
  '1 pet': '1 peter', '2 pet': '2 peter',
  '1 pt': '1 peter', '2 pt': '2 peter', '1 pe': '1 peter', '2 pe': '2 peter',
  '1 jn': '1 john', '2 jn': '2 john', '3 jn': '3 john',
  'jud': 'jude', 'jd': 'jude',
  'rev': 'revelation', 'revelations': 'revelation', 'apocalypse': 'revelation',
};

export type BibleBook = (typeof bibleBooks)[number];

/**
 * Resolve a user-typed book name to its canonical `bibleBooks` entry.
 * Handles punctuation ("Ps."), written/roman ordinals ("First John", "I John"),
 * missing spaces ("1Corinthians"), and the alias table above.
 */
export function resolveBibleBook(raw: string): BibleBook | null {
  if (!raw?.trim()) return null;

  let name = raw
    .toLowerCase()
    .replace(/\./g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  // "First" / "1st" / "I" → "1", and so on for II / III.
  name = name
    .replace(/^(?:first|1st|i)\s+/, '1 ')
    .replace(/^(?:second|2nd|ii)\s+/, '2 ')
    .replace(/^(?:third|3rd|iii)\s+/, '3 ');

  // "1Corinthians" → "1 corinthians"
  name = name.replace(/^([1-3])\s*/, '$1 ');

  const canonical = BOOK_ALIASES[name] ?? name;
  return bibleBooks.find(b => b.name.toLowerCase() === canonical) ?? null;
}

// Bible versions available through api.bible
export const bibleVersions = [
  { id: '06125adad2d5898a-01', name: 'King James Version', short: 'KJV' },
  { id: '9879dbb7cfe39e4d-01', name: 'English Standard Version', short: 'ESV' },
  { id: '7142879509583d59-01', name: 'New International Version', short: 'NIV' },
  { id: '314f85f2682e1934-01', name: 'New King James Version', short: 'NKJV' },
];

interface BiblePassage {
  reference: string;
  text: string;
  version: string;
}

// In-memory cache for verse counts and passages
const verseCountCache: Record<string, number> = {};
const passageCache: Record<string, BiblePassage> = {};

// Fallback verse counts for common books when API fails
const fallbackVerseCounts: Record<string, Record<number, number>> = {
  'GEN': { 1: 31, 2: 25, 3: 24, 4: 26, 5: 32 },
  'EXO': { 1: 22, 2: 25, 3: 22, 4: 31, 5: 23 },
  'JHN': { 1: 51, 2: 25, 3: 36, 4: 54, 5: 47 },
  'PSA': { 1: 6, 23: 6, 119: 176, 121: 8, 150: 6 },
  'MAT': { 1: 25, 5: 48, 6: 34, 7: 29, 28: 20 },
  'ROM': { 1: 32, 3: 31, 5: 21, 8: 39, 12: 21 }
};

// Expanded fallback passages for common verses
const fallbackPassages: Record<string, string> = {
  // John 3:16-17
  'John 3:16': 'For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life.',
  'John 3:17': 'For God sent not his Son into the world to condemn the world; but that the world through him might be saved.',
  
  // Genesis 1:1-3
  'Genesis 1:1': 'In the beginning God created the heaven and the earth.',
  'Genesis 1:2': 'And the earth was without form, and void; and darkness was upon the face of the deep. And the Spirit of God moved upon the face of the waters.',
  'Genesis 1:3': 'And God said, Let there be light: and there was light.',
  
  // Psalm 23
  'Psalm 23:1': 'The LORD is my shepherd; I shall not want.',
  'Psalm 23:2': 'He maketh me to lie down in green pastures: he leadeth me beside the still waters.',
  'Psalm 23:3': 'He restoreth my soul: he leadeth me in the paths of righteousness for his name\'s sake.',
  'Psalm 23:4': 'Yea, though I walk through the valley of the shadow of death, I will fear no evil: for thou art with me; thy rod and thy staff they comfort me.',
  'Psalm 23:5': 'Thou preparest a table before me in the presence of mine enemies: thou anointest my head with oil; my cup runneth over.',
  'Psalm 23:6': 'Surely goodness and mercy shall follow me all the days of my life: and I will dwell in the house of the LORD for ever.',
  
  // Romans 8:28-30
  'Romans 8:28': 'And we know that all things work together for good to them that love God, to them who are the called according to his purpose.',
  'Romans 8:29': 'For whom he did foreknow, he also did predestinate to be conformed to the image of his Son, that he might be the firstborn among many brethren.',
  'Romans 8:30': 'Moreover whom he did predestinate, them he also called: and whom he called, them he also justified: and whom he justified, them he also glorified.',
  
  // Matthew 5:3-10 (Beatitudes)
  'Matthew 5:3': 'Blessed are the poor in spirit: for theirs is the kingdom of heaven.',
  'Matthew 5:4': 'Blessed are they that mourn: for they shall be comforted.',
  'Matthew 5:5': 'Blessed are the meek: for they shall inherit the earth.',
  'Matthew 5:6': 'Blessed are they which do hunger and thirst after righteousness: for they shall be filled.',
  'Matthew 5:7': 'Blessed are the merciful: for they shall obtain mercy.',
  'Matthew 5:8': 'Blessed are the pure in heart: for they shall see God.',
  'Matthew 5:9': 'Blessed are the peacemakers: for they shall be called the children of God.',
  'Matthew 5:10': 'Blessed are they which are persecuted for righteousness\' sake: for theirs is the kingdom of heaven.',
  
  // Philippians 4:4-7
  'Philippians 4:4': 'Rejoice in the Lord alway: and again I say, Rejoice.',
  'Philippians 4:5': 'Let your moderation be known unto all men. The Lord is at hand.',
  'Philippians 4:6': 'Be careful for nothing; but in every thing by prayer and supplication with thanksgiving let your requests be made known unto God.',
  'Philippians 4:7': 'And the peace of God, which passeth all understanding, shall keep your hearts and minds through Christ Jesus.',
  
  // Isaiah 40:28-31
  'Isaiah 40:28': 'Hast thou not known? hast thou not heard, that the everlasting God, the LORD, the Creator of the ends of the earth, fainteth not, neither is weary? there is no searching of his understanding.',
  'Isaiah 40:29': 'He giveth power to the faint; and to them that have no might he increaseth strength.',
  'Isaiah 40:30': 'Even the youths shall faint and be weary, and the young men shall utterly fall:',
  'Isaiah 40:31': 'But they that wait upon the LORD shall renew their strength; they shall mount up with wings as eagles; they shall run, and not be weary; and they shall walk, and not faint.'
};

export async function fetchBiblePassage(reference: string, versionId: string): Promise<BiblePassage> {
  const apiKey = import.meta.env.VITE_BIBLE_API_KEY;
  if (!apiKey) {
    throw new Error('Bible API key not found');
  }

  try {
    // Check if we have this passage in cache
    const cacheKey = `passage_${versionId}_${reference}`;
    if (passageCache[cacheKey]) {
      return passageCache[cacheKey];
    }

    // Parse the reference to get book, chapter, and verses
    const referenceMatch = reference.match(/^([\w\s.]+?)\s*\.?\s+(\d+)(?::(\d+)(?:-(\d+))?)?$/);
    if (!referenceMatch) {
      throw new Error('Invalid reference format');
    }

    const [, bookName, chapter, startVerse, endVerse] = referenceMatch;
    const book = resolveBibleBook(bookName);
    if (!book) {
      throw new Error('Book not found');
    }

    // Check if we have a fallback for this reference
    const startVerseNum = startVerse ? parseInt(startVerse) : 1;
    const endVerseNum = endVerse ? parseInt(endVerse) : startVerseNum;
    
    // Build text from fallback passages if available
    let text = '';
    let usedFallback = false;
    
    for (let i = startVerseNum; i <= endVerseNum; i++) {
      const verseRef = `${bookName} ${chapter}:${i}`;
      if (fallbackPassages[verseRef]) {
        text += `[${i}] ${fallbackPassages[verseRef]}\n\n`;
        usedFallback = true;
      }
    }
    
    if (usedFallback && text) {
      const version = bibleVersions.find(v => v.id === versionId)?.short || 'KJV';
      
      const passage = {
        reference,
        text: text.trim(),
        version
      };
      
      passageCache[cacheKey] = passage;
      return passage;
    }

    // Use the /passages endpoint to fetch exactly the requested verse range in one call.
    // This avoids the chapter-fetch-then-filter approach which could truncate multi-verse ranges.
    const start = startVerse ? parseInt(startVerse) : 1;
    const end = endVerse ? parseInt(endVerse) : start;
    const passageId = startVerse
      ? `${book.id}.${chapter}.${start}-${book.id}.${chapter}.${end}`
      : `${book.id}.${chapter}`;

    const passageResponse = await fetch(
      `https://api.scripture.api.bible/v1/bibles/${versionId}/passages/${passageId}?content-type=text&include-notes=false&include-titles=false&include-chapter-numbers=false&include-verse-numbers=true&include-verse-spans=false`,
      { headers: { 'api-key': apiKey } }
    );

    if (!passageResponse.ok) {
      throw new Error(`Failed to fetch passage: ${passageResponse.status}`);
    }

    const passageData = await passageResponse.json();
    const rawText: string = passageData.data?.content ?? '';

    // Extract [verse] text pairs — use dotAll so newlines inside verse text are captured
    const verseRegex = /\[(\d+)\]\s*([\s\S]*?)(?=\[\d+\]|$)/g;
    const verses: { number: number; text: string }[] = [];
    let verseMatch;
    while ((verseMatch = verseRegex.exec(rawText)) !== null) {
      const verseText = verseMatch[2].replace(/\s+/g, ' ').trim();
      if (verseText) verses.push({ number: parseInt(verseMatch[1]), text: verseText });
    }

    text = verses.map(v => `[${v.number}] ${v.text}`).join('\n\n');

    // Get the version short name
    const version = bibleVersions.find(v => v.id === versionId)?.short || 'KJV';

    const passage = {
      reference,
      text,
      version
    };

    // Cache the result
    passageCache[cacheKey] = passage;
    
    return passage;
  } catch (error) {
    console.error('Error fetching Bible passage:', error);
    
    // Try to provide a fallback response
    const simplifiedRef = reference.replace(/:\d+-\d+/, '').replace(/:\d+/, '');
    for (const key of Object.keys(fallbackPassages)) {
      if (simplifiedRef.includes(key.split(':')[0])) {
        const version = bibleVersions.find(v => v.id === versionId)?.short || 'KJV';
        return {
          reference,
          text: `[1] ${fallbackPassages[key]}`,
          version
        };
      }
    }
    
    // If all else fails, return a generic fallback
    return {
      reference,
      text: `[1] For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life. (John 3:16)`,
      version: 'KJV'
    };
  }
}

export function useVerseCount(book: string, chapter: number) {
  const [verseCount, setVerseCount] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!book || !chapter) {
      setVerseCount(0);
      setError(null);
      setLoading(false);
      return;
    }

    const fetchVerseCount = async () => {
      try {
        setLoading(true);
        setError(null);

        const apiKey = import.meta.env.VITE_BIBLE_API_KEY;
        if (!apiKey) {
          throw new Error('Bible API key not found');
        }

        // Check if we have this count in cache
        const cacheKey = `verseCount_${book}_${chapter}`;
        if (verseCountCache[cacheKey]) {
          setVerseCount(verseCountCache[cacheKey]);
          setLoading(false);
          return;
        }

        // Check if we have a fallback for this book and chapter
        if (fallbackVerseCounts[book]?.[chapter]) {
          const count = fallbackVerseCounts[book][chapter];
          verseCountCache[cacheKey] = count;
          setVerseCount(count);
          setLoading(false);
          return;
        }

        // Use KJV as the reference version for verse counts
        const versionId = '06125adad2d5898a-01';
        
        const response = await fetch(
          `https://api.scripture.api.bible/v1/bibles/${versionId}/chapters/${book}.${chapter}`,
          {
            headers: {
              'api-key': apiKey
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const count = data.data.verseCount || 0;
        
        // Cache the result
        verseCountCache[cacheKey] = count;
        setVerseCount(count);
      } catch (error) {
        console.error('Error fetching verse count:', error);
        
        // Try to use a fallback from a similar book
        let fallbackCount = 0;
        
        // Default fallback based on book type
        if (book.startsWith('PSA')) fallbackCount = 6;  // Default psalm length
        else if (book.startsWith('GEN') || book.startsWith('EXO')) fallbackCount = 30;  // Default for Genesis/Exodus
        else fallbackCount = 25;  // Default for other books
        
        setError(`Could not fetch verse count. Using estimated count of ${fallbackCount}.`);
        setVerseCount(fallbackCount);
      } finally {
        setLoading(false);
      }
    };

    fetchVerseCount();
  }, [book, chapter]);

  return { verseCount, error, loading };
}